/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Add_MemberInputs */

const th_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มสมาชิก`)
};

const en_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add member`)
};

const ja_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーを追加`)
};

const zh_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加成员`)
};

const es_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir miembro`)
};

const pt_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar membro`)
};

const id_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah anggota`)
};

const fr_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un membre`)
};

const tl_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magdagdag ng miyembro`)
};

const vi_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm thành viên`)
};

const ko_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구성원 추가`)
};

const de_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied hinzufügen`)
};

const ru_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить участника`)
};

const tr_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üye ekle`)
};

const it_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi membro`)
};

const pl_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj członka`)
};

const uk_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати учасника`)
};

const hi_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्य जोड़ें`)
};

const ar_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة عضو`)
};

const ms_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah ahli`)
};

const bn_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সদস্য যোগ করুন`)
};

const zh_tw2_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增成員`)
};

const zh_hk2_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增成員`)
};

const ur_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رکن شامل کریں`)
};

const fa_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن عضو`)
};

const sw_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza mwanachama`)
};

const nl_org_add_member = /** @type {(inputs: Org_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lid toevoegen`)
};

/**
* | output |
* | --- |
* | "Add member" |
*
* @param {Org_Add_MemberInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_add_member = /** @type {((inputs?: Org_Add_MemberInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Add_MemberInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_add_member(inputs)
	if (locale === "ja") return ja_org_add_member(inputs)
	if (locale === "zh") return zh_org_add_member(inputs)
	if (locale === "es") return es_org_add_member(inputs)
	if (locale === "pt") return pt_org_add_member(inputs)
	if (locale === "id") return id_org_add_member(inputs)
	if (locale === "fr") return fr_org_add_member(inputs)
	if (locale === "tl") return tl_org_add_member(inputs)
	if (locale === "vi") return vi_org_add_member(inputs)
	if (locale === "ko") return ko_org_add_member(inputs)
	if (locale === "de") return de_org_add_member(inputs)
	if (locale === "ru") return ru_org_add_member(inputs)
	if (locale === "tr") return tr_org_add_member(inputs)
	if (locale === "it") return it_org_add_member(inputs)
	if (locale === "pl") return pl_org_add_member(inputs)
	if (locale === "uk") return uk_org_add_member(inputs)
	if (locale === "hi") return hi_org_add_member(inputs)
	if (locale === "ar") return ar_org_add_member(inputs)
	if (locale === "ms") return ms_org_add_member(inputs)
	if (locale === "bn") return bn_org_add_member(inputs)
	if (locale === "zh-TW") return zh_tw2_org_add_member(inputs)
	if (locale === "zh-HK") return zh_hk2_org_add_member(inputs)
	if (locale === "ur") return ur_org_add_member(inputs)
	if (locale === "fa") return fa_org_add_member(inputs)
	if (locale === "sw") return sw_org_add_member(inputs)
	if (locale === "nl") return nl_org_add_member(inputs)
	return en_org_add_member(inputs)
});